<div class="filtered-user-list">
  <div class="container-multiselect">
    <ng-select
      [items]="dropdownList"
      bindLabel="name"
      bindValue="id"
      (ngModelChange)="onSelectionChanged($event)"
      [multiple]="true"
      [(ngModel)]="selectedUserList"
      [placeholder]="placeHolderString"
      [virtualScroll]="true"
      [notFoundText]="'User not found'">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">{{ item.name }}</span>
        <span
          class="ng-value-icon right"
          (click)="clearUser(item.id)"
          aria-hidden="true">
          ×
        </span>
      </ng-template>
    </ng-select>
  </div>
  <div class="users" #divParent>
    <virtual-scroller
      [ngStyle]="{ height: height }"
      #scroll
      [bufferAmount]="5"
      [items]="getSortedUsers()">
      <div
        class="user d-flex"
        *ngFor="let user of scroll.viewPortItems"
        (click)="
          (selectedUsers[user._id] || isFilteredUser(user)) && toggleUser(user)
        "
        [class.selected]="selectedUsers[user._id]"
        [class.unselectable]="!isFilteredUser(user)">
        <div class="col-1">
          <profile-picture [noMargin]="true" [user]="user"></profile-picture>
        </div>
        <div class="col-4 username">{{ user.first_name }} {{ user.name }}</div>
        <div class="col-4">
          {{ user.organization }}
        </div>
        <div class="col-3">
          {{ user.location ? user.location.country : '' }}
        </div>
      </div>
    </virtual-scroller>
  </div>
</div>
